import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Navbar from "../../components/common/Navbar";
import Footer from "../../components/common/Footer";

const ThirdPartyBusinessServices = () => {
  return (
    <main>

      <Helmet>
        <title>
          Top Third Party Business Services Company in India
        </title>

        <meta
          name="description"
          content="Get reliable business outsourcing services and third party business solutions for smooth operations and business growth."
        />

        <meta
          name="keywords"
          content="business outsourcing services,third party business services,outsourcing services company,business support outsourcing,b2b outsourcing company"
        />

        <link
          rel="canonical"
          href="https://www.businessmateworkflow.in/third-party-business-services"
        />

        <meta
          property="og:title"
          content="Third Party Business Services"
        />

        <meta
          property="og:description"
          content="Connect with trusted third-party service providers across digital marketing, IT, finance, HR, and more."
        />

        <meta
          property="og:image"
          content="https://www.businessmateworkflow.in/uploads/profile-photos/profile-1759859276632-265381735.jpg"
        />

        <meta
          property="og:url"
          content="https://www.businessmateworkflow.in/third-party-business-services"
        />

      </Helmet>

      <Navbar />

      {/* HERO SECTION */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
          padding: "40px 0",
          color: "#fff",
        }}
      >
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT CONTENT */}
            <div className="col-lg-6">

              <span
                style={{
                  background: "#06b590",
                  padding: "8px 18px",
                  borderRadius: "30px",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "inline-block",
                  marginBottom: "20px",
                }}
              >
                Business Support Services
              </span>

              <h1
                style={{
                  fontSize: "52px",
                  fontWeight: "800",
                  lineHeight: "1.2",
                  marginBottom: "25px",
                  color: "#fff",
                }}
              >
                Professional Third-Party Business Services
              </h1>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "2",
                  color: "#cbd5e1",
                }}
              >
                Modern businesses often require external support for operations, marketing, IT, HR, finance, logistics, and customer service. Finding reliable service providers can be difficult, especially when businesses face issues like delayed delivery, poor communication, or unprofessional service quality.
              </p>

              <p
                style={{
                  fontSize: "17px",
                  lineHeight: "2",
                  color: "#cbd5e1",
                  marginTop: "15px",
                }}
              >
                At BusinessMateWorkflow™, we provide a structured platform where businesses can connect with trusted third-party service providers across multiple categories.
              </p>

            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 text-center mt-5 mt-lg-0">

              <img
                src="/uploads/profile-photos/profile-1759859276632-265381735.jpg"
                alt="Third Party Business Services"
                className="img-fluid"
                loading="lazy"
                style={{
                  borderRadius: "25px",
                  boxShadow: "0 25px 60px rgba(0,0,0,0.35)",
                  maxHeight: "550px",
                  objectFit: "cover",
                }}
              />

            </div>

          </div>
        </div>
      </section>

      {/* SERVICE CATEGORIES SECTION */}
      <section
        style={{
          padding: "100px 0",
          background: "#f8fafc",
        }}
      >
        <div className="container">

          <div className="text-center mb-5">
            <h2
              style={{
                fontSize: "42px",
                fontWeight: "800",
                marginBottom: "20px",
              }}
            >
              Service Categories Available
            </h2>
          </div>

          <div className="row g-4">

            {/* Digital Marketing Services */}
            <div className="col-lg-6">
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>📢</div>
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginBottom: "20px",
                    color: "#0f172a",
                  }}
                >
                  Digital Marketing Services
                </h3>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ SEO services</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Social media management</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Paid advertising solutions</li>
                </ul>
              </div>
            </div>

            {/* IT Services */}
            <div className="col-lg-6">
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>💻</div>
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginBottom: "20px",
                    color: "#0f172a",
                  }}
                >
                  IT Services
                </h3>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Website development</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Software development</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Mobile application solutions</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ IT support services</li>
                </ul>
              </div>
            </div>

            {/* Finance & Accounting Services */}
            <div className="col-lg-6">
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>📊</div>
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginBottom: "20px",
                    color: "#0f172a",
                  }}
                >
                  Finance & Accounting Services
                </h3>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ GST & tax filing</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Bookkeeping support</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Financial consultancy</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Accounting services</li>
                </ul>
              </div>
            </div>

            {/* HR & Recruitment Support */}
            <div className="col-lg-6">
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "15px" }}>👨‍💼</div>
                <h3
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginBottom: "20px",
                    color: "#0f172a",
                  }}
                >
                  HR & Recruitment Support
                </h3>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Payroll management</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Recruitment assistance</li>
                  <li style={{ padding: "8px 0", color: "#475569" }}>✅ Staffing support</li>
                </ul>
              </div>
            </div>

          </div>

          <div className="text-center mt-4">
            <p
              style={{
                fontSize: "16px",
                color: "#475569",
                marginTop: "20px",
                padding: "15px",
                background: "#e6f7f2",
                borderRadius: "12px",
                display: "inline-block",
              }}
            >
              💡 Businesses looking for internal workforce support can also explore our Skilled Employee Services.
            </p>
          </div>

        </div>
      </section>

      {/* WHY OUR PLATFORM IS DIFFERENT SECTION */}
      <section
        style={{
          padding: "100px 0",
          background: "#fff",
        }}
      >
        <div className="container">

          <div className="row align-items-center">
            <div className="col-lg-7">
              <h2
                style={{
                  fontSize: "42px",
                  fontWeight: "800",
                  marginBottom: "25px",
                }}
              >
                Why Our Platform is Different
              </h2>

              <p
                style={{
                  fontSize: "18px",
                  lineHeight: "1.9",
                  color: "#475569",
                  marginBottom: "25px",
                }}
              >
                We focus on maintaining a trusted and professional business ecosystem. Service providers receiving repeated complaints or fraudulent reports may be reviewed and removed from the platform after verification.
              </p>

              <div
                style={{
                  background: "#06b590",
                  padding: "25px",
                  borderRadius: "15px",
                  color: "#fff",
                  marginTop: "20px",
                }}
              >
                <div style={{ fontSize: "30px", marginBottom: "10px" }}>⭐</div>
                <p style={{ fontSize: "17px", lineHeight: "1.8", margin: 0, fontWeight: "500" }}>
                  This helps maintain trust, transparency, and service quality for businesses.
                </p>
              </div>
            </div>

            <div className="col-lg-5 mt-5 mt-lg-0">
              <div
                style={{
                  background: "#f8fafc",
                  padding: "40px",
                  borderRadius: "25px",
                  textAlign: "center",
                  border: "1px solid #e2e8f0",
                }}
              >
                <div style={{ fontSize: "60px", marginBottom: "20px" }}>🔒</div>
                <h3 style={{ fontSize: "22px", fontWeight: "700", marginBottom: "15px", color: "#0f172a" }}>
                  Trust & Transparency
                </h3>
                <p style={{ color: "#64748b", lineHeight: "1.7" }}>
                  Verified service providers<br />
                  Quality assurance<br />
                  Professional ecosystem
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CTA SECTION */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #06b590 0%, #059669 100%)",
          padding: "90px 0",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <div className="container">

          <h2
            style={{
              fontSize: "48px",
              fontWeight: "800",
              marginBottom: "20px",
            }}
          >
            Start Your Business Journey Today
          </h2>

          <p
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              fontSize: "18px",
              lineHeight: "1.9",
              marginBottom: "35px",
            }}
          >
            If you are looking for business opportunities, partnerships, employees, or professional services, you can contact us. Our team will understand your requirement and connect you with the right solution.
          </p>

          <Link to="/contact">
            <button
              className="btn"
              style={{
                background: "#fff",
                color: "#06b590",
                padding: "15px 40px",
                borderRadius: "12px",
                fontWeight: "700",
                border: "none",
                fontSize: "18px",
              }}
            >
              Get Started Now
            </button>
          </Link>

        </div>
      </section>

      <Footer />

    </main>
  );
};

export default ThirdPartyBusinessServices;